import { formatMoney } from '@theme/money-formatting';

(function () {
  'use strict';

  if (window.__versandhinweisBereit) return;
  window.__versandhinweisBereit = true;

  let tarifCent = null;
  let auswahlCent = 0;

  function zeilen() {
    return document.querySelectorAll('[data-vsh]');
  }

  function schwelleCent(liste, land) {
    if (!liste || !land) return null;
    const gesucht = String(land).trim().toUpperCase();

    for (const roh of String(liste).split(',')) {
      const teile = roh.split(':');
      if (teile.length < 2) continue;
      if (teile[0].trim().toUpperCase() !== gesucht) continue;
      const euro = parseFloat(teile[1].trim().replace(',', '.'));
      if (!isFinite(euro) || euro <= 0) return null;
      return Math.round(euro * 100);
    }
    return null;
  }

  function zeichnen() {
    zeilen().forEach((el) => {
      try {
        zeichneEine(el);
      } catch (e) {
        el.hidden = true;
        console.error('[Versandhinweis]', e);
      }
    });
  }

  function zeichneEine(el) {
      const zusage = el.getAttribute('data-vsh-frei') || '';
      const vorlage = el.getAttribute('data-vsh-ab-vorlage') || '';
      const format = el.getAttribute('data-vsh-money-format') || '';
      const waehrung = el.getAttribute('data-vsh-currency') || 'EUR';
      const schwelle = schwelleCent(
        el.getAttribute('data-vsh-liste'),
        el.getAttribute('data-vsh-land')
      );
      const korb = Number(el.getAttribute('data-vsh-korb') || 0) || 0;
      const preis = Number(el.getAttribute('data-vsh-preis') || 0) || 0;
      const auswahl = auswahlCent > 0 ? auswahlCent : preis;

      const summe = korb + auswahl;
      const beweisGilt = tarifCent !== null && korb > 0 && auswahl === 0;

      let text = '';
      let zusagend = false;

      if (beweisGilt) {
        if (tarifCent === 0) {
          text = zusage;
          zusagend = true;
        }
      } else if (schwelle !== null) {
        if (summe >= schwelle) {
          text = zusage;
          zusagend = true;
        } else if (vorlage && format) {
          text = vorlage.replace('%s', formatMoney(schwelle, format, waehrung));
        }
      } else if (tarifCent === 0 && korb > 0) {
        text = zusage;
        zusagend = true;
      }

      if (!text) {
        el.hidden = true;
        return;
      }
      if (el.textContent.trim() !== text) el.textContent = text;
      el.classList.toggle('vsh--frei', zusagend);
      el.hidden = false;
  }

  document.addEventListener('3idee:versandtarif', (e) => {
    const cent = e && e.detail && typeof e.detail.cent === 'number' ? e.detail.cent : null;
    tarifCent = cent;
    zeichnen();
  });

  document.addEventListener('3idee:auswahlpreis', (e) => {
    const cent = e && e.detail && typeof e.detail.cent === 'number' ? e.detail.cent : 0;
    auswahlCent = cent;
    zeichnen();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zeichnen);
  } else {
    zeichnen();
  }
})();
